module.exports = __webpack_public_path__ + "static/media/toucn-n-go.4d319a36.png";